export { default as translations } from './translations.json';

export const MAX_QUICK_REPLIES = 20;
export const TEMPLATE_VARS = ['{listingTitle}', '{customerName}', '{bookingDate}'];

/**
 * Get quick replies from user.
 * @param {Object|null} user
 * @returns {Object[]}
 */
export const getQuickReplies = (user) => {
  const replies = user?.attributes?.profile?.privateData?.quickReplies || [];
  return [...replies].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
};

/**
 * Fill template variables in a quick reply.
 * @param {string} template
 * @param {Object} vars — { listingTitle, customerName, bookingDate }
 * @returns {string}
 */
export const fillTemplate = (template, vars = {}) => {
  if (!template) return '';
  return template
    .replace('{listingTitle}', vars.listingTitle || '')
    .replace('{customerName}', vars.customerName || '')
    .replace('{bookingDate}', vars.bookingDate || '');
};
